
import React, { useState } from "react";
import { useContext } from "react";
import Modal from "react-modal";
import { ThemeContext } from "../context/ThemeProvider";
import { getThemeBlackWhiteColor } from "../utils/themeUtils";

const ImageModal = ({ isOpen, onRequestClose, imgSrc }) => {
  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => {
    setZoom(zoom + 10);
  };

  const handleZoomOut = () => {
    if (zoom > 100) setZoom(zoom - 10);
  };

  const customStyles = {
    content: {
      position: "absolute",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)", 
      maxWidth: "80%", 
      maxHeight: "80%",
      overflow: "auto", 
      resize: "both", 
      boxSizing: "border-box", 
      padding: "20px", 
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.3)", 
    },
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      <img
        src={imgSrc}
        style={{ width: "100%", height: "auto" }}
        alt="Modal Content"
      />
    </Modal>
  );
};

const HTMLContent = ({ index, htmlContent, style = {}, className = "" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageSrc, setSelectedImageSrc] = useState("");
  const { theme, currentTheme} = useContext(ThemeContext);
  

  const handleContentClick = (e) => {
    if (e.target.tagName === "IMG") {
      setSelectedImageSrc(e.target.src);
      setIsModalOpen(true);
    }
  };

 
  const combinedStyles = {
    color: `${getThemeBlackWhiteColor(theme, currentTheme)}`,
    ...style,
  };


  const combinedClassNames = `text-base/loose font-normal ${className}`;

  return (
    <div>
      <div
        key={index}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        onClick={handleContentClick}
        style={combinedStyles}
        className={combinedClassNames}
      />
      <ImageModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        imgSrc={selectedImageSrc}
      />
    </div>
  );
};

export default HTMLContent;
